import React from 'react'
import Privacy from '../../components/Privacy'

function PrivacyPage() {
  return (
   <Privacy/>
  )
}

export default PrivacyPage